import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Theme } from '../../layout/Theme';
import './RestaurantMarker.scss';

function RestaurantMarkerBase({ name, tempClosed }) {
  const abbr = useMemo(
    () => (name || '').slice(0, 2).toUpperCase() || 'R',
    [name]
  );

  return (
    <div className="restaurant-marker-container">
      <div className={clsx('marker', { 'temp-closed': tempClosed })}>
        {abbr}
      </div>
    </div>
  );
}

RestaurantMarkerBase.propTypes = {
  name: PropTypes.string,
  tempClosed: PropTypes.bool,
};

RestaurantMarkerBase.defaultProps = {
  name: '',
  tempClosed: false,
};

export function RestaurantMarker({ name, tempClosed }) {
  return (
    <Theme>
      <RestaurantMarkerBase name={name} tempClosed={tempClosed} />
    </Theme>
  );
}

RestaurantMarker.propTypes = {
  name: PropTypes.string,
  tempClosed: PropTypes.bool,
};

RestaurantMarker.defaultProps = {
  name: '',
  tempClosed: false,
};
